<template>
    <div>
        <b-form-group :label="field.label" :label-for="`id_${field._id}`">
            <b-form-select
                v-model="model"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :options="options"
                :text-field="textField"
                :value-field="valueField"
                class="form-control custom-select"
                @change="onChange($event)"
            >
                <option slot="first" selected :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import _ from 'lodash'
import request from '@/utils/request'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            model: null,
            options: [],
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onChange(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )
            }
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
    },

    async mounted() {
        try {
            var self = this
            // fetch the list of associated configurations
            if (this.field.association) {
                let { data } = await request({
                    url: `/configurations/${this.field.association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        ref: 'dropdown',
                        perPage: 1000,
                    },
                })
                this.options = data.data
            }
        } catch (error) {
            console.log(error)
        }
    },
}
</script>
